export const DATA_TIERING_LICENSE_TITLE = "license_check.disabled_title";
export const DATA_TIERING_LICENSE_TEXT = "license_check.disabled_text";
export const DATA_TIERING_UPSELL_TITLE = "license_check.upsell_title";
export const DATA_TIERING_UPSELL_TEXT = "license_check.upsell_text";
